import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext.js';
import './UsageMeter.css';

export default function UsageMeter() {
  const { token } = useAuth();
  const [usage, setUsage] = useState({
    tokens: 0,
    images: 0,
    videos: 0,
  });
  const [credits, setCredits] = useState({
    credits: 0,
    freeCredits: 0,
    paidCredits: 0,
  });
  const [loading, setLoading] = useState(true);

  const fetchUsage = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(apiUrl ? `${apiUrl}/credits/usage` : '/credits/usage', {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setUsage(data);
      }
    } catch (error) {
      console.error('Error fetching usage:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCredits = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(apiUrl ? `${apiUrl}/credits/credits` : '/credits/credits', {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setCredits(data);
      }
    } catch (error) {
      console.error('Error fetching credits:', error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchUsage();
      fetchCredits();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (!token) {
    return null;
  }

  if (loading) {
    return (
      <div className="usage-meter-container" aria-busy="true">
        <div className="usage-meter-header">
          <h3>💰 Usage & Credits</h3>
        </div>
        <p className="usage-meter-loading">Loading usage…</p>
      </div>
    );
  }

  return (
    <div className="usage-meter-container">
      <div className="usage-meter-header">
        <h3>💰 Usage & Credits</h3>
      </div>

      <div className="credits-display">
        <div className="credits-main">
          <div className="credits-value">{credits.credits}</div>
          <div className="credits-label">Total Credits</div>
        </div>
        <div className="credits-breakdown">
          <div className="credit-item">
            <span className="credit-type">Free:</span>
            <span className="credit-amount">{credits.freeCredits}</span>
          </div>
          <div className="credit-item">
            <span className="credit-type">Paid:</span>
            <span className="credit-amount">{credits.paidCredits}</span>
          </div>
        </div>
      </div>

      <div className="usage-stats">
        <div className="usage-stat">
          <div className="usage-stat-icon">📊</div>
          <div className="usage-stat-content">
            <div className="usage-stat-label">Tokens Used</div>
            <div className="usage-stat-value">{usage.tokens.toLocaleString()}</div>
          </div>
        </div>
        <div className="usage-stat">
          <div className="usage-stat-icon">🖼️</div>
          <div className="usage-stat-content">
            <div className="usage-stat-label">Images Used</div>
            <div className="usage-stat-value">{usage.images}</div>
          </div>
        </div>
        <div className="usage-stat">
          <div className="usage-stat-icon">🎬</div>
          <div className="usage-stat-content">
            <div className="usage-stat-label">Videos Processed</div>
            <div className="usage-stat-value">{usage.videos}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

